
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange } from "../../../library-js/dom-tools/EventListeners";
import { InspectorField } from "./InspectorField";

export class StringField extends InspectorField<string>
{
  static readonly type = new ElementType( "string--field" );

  protected _inputField:HTMLInputElement;

  createElement() 
  {
    let element = StringField.type.create();
    InspectorField.flag.set( element );

    let inputField = ElementType.input.create();
    this._inputField = inputField;
    AttributeValue.type_text.set( inputField );

    element.appendChild( inputField);

    OnChange.add( inputField,
      ()=>
      {
        this.value = inputField.value;
        this.onChange.dispatch( this.value );
      }
    );

    this._element = element;
  }

  syncValueToElement()
  {
    this._inputField.value = this._value;
  }
  
  
}